import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y,
    EffectFade,
    Thumbs
} from 'swiper/modules';

document.querySelectorAll('.swiperFullwidthSlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperFullwidthBlock');
    const nextButton = container.querySelector('.swiperFullwidthNext');
    const prevButton = container.querySelector('.swiperFullwidthPrev');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, Pagination, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });
});

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperNewsBlock');
    const nextButton = container.querySelector('.swiperNewsNext');
    const prevButton = container.querySelector('.swiperNewsPrev');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperOverflowSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperOverflowBlock');
    const nextButton = container.querySelector('.swiperOverflowNext');
    const prevButton = container.querySelector('.swiperOverflowPrev');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperFullwidthVerticalSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperFullwidthVerticalBlock');
    const nextButton = container.querySelector('.swiperFullwidthVerticalNext');
    const prevButton = container.querySelector('.swiperFullwidthVerticalPrev');

    const swiper = new Swiper(slider, {
        modules: [Navigation, Pagination, A11y],
        a11y: {
            enabled: true
        },
        direction: "vertical",
        
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        slidesPerView: 1,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            576: {
                pagination: {
                    el: ".swiper-pagination.vertical",
                    clickable: true,
                },
            },
        }
    });
});

document.querySelectorAll('.swiperCenteredSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperCenteredBlock');
    const nextButton = container.querySelector('.swiperCenteredNext');
    const prevButton = container.querySelector('.swiperCenteredPrev');
    const sliderProgress = container.querySelector('.swiper-pagination');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true
        },
        centeredSlides: true,
        loop: true,
        pagination: {
            el: sliderProgress,
            type: "progressbar",
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperVariableSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperVariableBlock');
    const nextButton = container.querySelector('.swiperVariableNext');
    const prevButton = container.querySelector('.swiperVariablePrev');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        slidesPerView: "auto",
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                spaceBetween: 16,
            },
            992: {
                spaceBetween: 30,
            }
        }
    });
});

document.querySelectorAll('.swiperThumbnailSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperThumbnail');
    const nextButton = container.querySelector('.swiperThumbnailNext');
    const prevButton = container.querySelector('.swiperThumbnailPrev');
    const thumbSliderFind = container.querySelector('.swiperThumbnailThumb');
    const thumbSliderId = thumbSliderFind.id;
    const thumbSlider = document.getElementById(thumbSliderId);

    const swiperThumb = new Swiper(thumbSlider, {
        modules: [Navigation, A11y, Thumbs],
        a11y: {
            enabled: true
        },
        direction: "vertical",
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
    });

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, Thumbs, EffectFade],
        a11y: {
            enabled: true
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        thumbs: {
            swiper: swiperThumb,
        },
    });

    
});
